import { Flex, type FlexProps } from "@redotech/redo-web/flex";
import { ReactNode } from "react";

export function StickyFooter({
  children,
  bgColor = "primary",
  pb = "3xl",
  sticky = true,
}: {
  children: ReactNode;
  bgColor?: "primary" | "secondary";
  pb?: FlexProps["pb"];
  sticky?: boolean;
}) {
  return (
    <Flex
      bgColor={bgColor}
      bottom={sticky ? "0" : undefined}
      data-ui="sticky-footer"
      flexDirection="column"
      gap="none"
      pb={pb}
      position={sticky ? "sticky" : undefined}
      w="full"
    >
      {children}
    </Flex>
  );
}
